import { IEvent } from "@studyportals/event-aggregation-service-interface";

export class SearchPageRefreshText implements IEvent {
	public static readonly EventType = 'SearchPageRefreshText';

	public readonly timestamp = new Date();
	public readonly eventType = SearchPageRefreshText.EventType;
	public readonly text: string;

	constructor(text: string) {
		this.text = text;
	}

	public static is(event: IEvent): event is SearchPageRefreshText {
		return event.eventType === SearchPageRefreshText.EventType;
	}
}
